/* eslint-disable react/display-name */
import { CSSProperties, memo } from 'react'

export const MarkersOverlay = memo(() => {
  const containerStyle: CSSProperties = {
    position: 'absolute',
    height: '100%',
    width: '100%',
    cursor: 'none',
    backgroundColor: 'unset',
    background: 'unset',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const contentStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    backgroundColor: ' rgba(77, 75, 231, 0.05)',
    borderRadius: '8px',
    border: '2px solid #4D4BE7',
  }

  return (
    <div style={containerStyle}>
      <div style={contentStyle} />
    </div>
  )
})
